import { render, staticRenderFns } from "./PaymentSuccessModal.vue?vue&type=template&id=143b0316&scoped=true"
import script from "./PaymentSuccessModal.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessModal.vue?vue&type=style&index=0&id=143b0316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b0316",
  null
  
)

export default component.exports